(() => {
  const config = window.funeralAuctionBan || {};
  const bannedCustomerIds = (config.bannedCustomerIds || []).map(String).filter(Boolean);
  const message = config.message || 'Jestes zbanowany z udzialu w aukcjach.';
  const auctionBlockSelector = [
    '.boa-auction-block',
    '#boa-completedAuction',
    '[id*="boa" i]',
    '[class*="boa" i]',
    '[id*="bid-online" i]',
    '[class*="bid-online" i]',
    '[id*="auction" i]',
    '[class*="auction" i]',
    '.shopify-app-block'
  ].join(',');
  const controlSelector = [
    'form',
    'button',
    '[role="button"]',
    'input',
    'select',
    'textarea',
    'a[class*="bid" i]',
    '[class*="bid" i]',
    '[class*="auction" i][type="submit"]'
  ].join(',');

  const currentCustomerIds = () => [
    config.customerId,
    window.ShopifyAnalytics?.meta?.page?.customerId,
    window.__st?.cid,
    window.Shopify?.customerId
  ].map((id) => String(id || '')).filter(Boolean);

  const isBannedCustomer = () => currentCustomerIds().some((id) => bannedCustomerIds.includes(id));

  const updateDebugState = () => {
    window.funeralAuctionBanDebug = {
      bannedCustomerIds,
      currentCustomerIds: currentCustomerIds(),
      isBannedCustomer: isBannedCustomer()
    };
  };

  const isLikelyAuctionElement = (element) => {
    const text = (element.textContent || '').toLowerCase();
    const idAndClass = `${element.id || ''} ${element.className || ''}`.toLowerCase();

    return (
      idAndClass.includes('boa') ||
      idAndClass.includes('auction') ||
      idAndClass.includes('bid-online') ||
      text.includes('highest bid') ||
      text.includes('current bid') ||
      text.includes('place bid') ||
      text.includes('bid now') ||
      text.includes('bid history') ||
      text.includes('total bid') ||
      text.includes('bid increment')
    );
  };

  const likelyAuctionBlocks = () => {
    const explicitBlocks = Array.from(document.querySelectorAll(auctionBlockSelector)).filter(isLikelyAuctionElement);
    const productInfoBlocks = Array.from(document.querySelectorAll('.product__info-container > *, .funeral-product-info *'))
      .filter((element) => element.children.length > 0 && isLikelyAuctionElement(element));

    return [...new Set([...explicitBlocks, ...productInfoBlocks])];
  };

  const ensureMessage = (container) => {
    if (!container || container.querySelector('.funeral-auction-ban-message')) return;

    const notice = document.createElement('div');
    notice.className = 'funeral-auction-ban-message';
    notice.setAttribute('role', 'alert');
    notice.textContent = message;
    container.appendChild(notice);
  };

  const blockAuctionControls = () => {
    updateDebugState();
    if (!isBannedCustomer()) return;

    document.body?.classList.add('customer-auction-banned');

    likelyAuctionBlocks().forEach((block) => {
      block.dataset.funeralAuctionBanned = 'true';
      Array.from(block.children).forEach((child) => {
        if (!child.classList.contains('funeral-auction-ban-message')) {
          child.setAttribute('aria-hidden', 'true');
          child.style.setProperty('display', 'none', 'important');
        }
      });
      block.querySelectorAll(controlSelector).forEach((control) => {
        control.setAttribute('aria-hidden', 'true');
        if ('disabled' in control) control.disabled = true;
        control.style.setProperty('display', 'none', 'important');
      });
      ensureMessage(block);
    });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', blockAuctionControls);
  } else {
    blockAuctionControls();
  }

  new MutationObserver(blockAuctionControls).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.setTimeout(blockAuctionControls, 500);
  window.setTimeout(blockAuctionControls, 1500);

  let retryCount = 0;
  const retryTimer = window.setInterval(() => {
    blockAuctionControls();
    retryCount += 1;

    if (retryCount >= 40 || isBannedCustomer()) {
      window.clearInterval(retryTimer);
    }
  }, 250);
})();
